import * as React from "react";
import { User, Tag } from "../../api/classes";
import Table from "./table";
import * as actions from "../../store/cases/actions";
import { connect } from "react-redux";
import { GlobalState } from "../../store";
import Loading from "../../components/loading";

interface Props {
  tags: Tag[];
  fetchTags: () => void;
}
class Tags extends React.Component<Props> {
  componentWillMount() {
    if (!this.props.tags) {
      this.props.fetchTags();
    }
  }
  render() {
    if (!this.props.tags) {
      return <Loading />;
    }
    return (
      <div
        style={{
          flex: 1,
          padding: 24,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          overflowY: "scroll"
        }}
      >
        <div
          style={{
            width: "100%",
            maxWidth: 1000,
            marginLeft: 24,
            marginRight: 24
          }}
        >
          <Table elements={this.props.tags} />
        </div>
      </div>
    );
  }
}
export default connect(
  (state: GlobalState, own: any) => ({
    tags: state.cases.tags
  }),
  dispatch => ({
    fetchTags: (): any => dispatch(actions.fetchTags())
  })
)(Tags);



// WEBPACK FOOTER //
// ./src/pages/tags/index.tsx